import { render, staticRenderFns } from "./window-replace.vue?vue&type=template&id=5d1d5b22&scoped=true&"
import script from "./window-replace.vue?vue&type=script&lang=js&"
export * from "./window-replace.vue?vue&type=script&lang=js&"
import style0 from "./window-replace.vue?vue&type=style&index=0&id=5d1d5b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d5b22",
  null
  
)

export default component.exports